import styled from 'styled-components';
import { Divider as MuiDivider } from '@mui/material';

export const Container = styled.div`
  flex-grow: 1;
  background-color: transparent;
`;

export const Header = styled.div`
  flex-grow: 1;
  text-align: right;
  background-color: transparent;
`;

export const Center = styled.div`
  flex-grow: 1;
  background-color: transparent;
`;

export const SotableItem = styled.div`
  display: block;
  margin-right: 0px;
  padding-left: 5px;
  padding-right: 5px;
  width: 100%;
  float: left;
  box-sizing: border-box;
`;

export const ContentCentered = styled.div`
  margin-top: 20px;
  width: 100%;
  text-align: center;
`;

export const Clearfix = styled.div`
  clear: both;
  display: table;
`;

export const Divider = styled(MuiDivider)`
  margin-top: 20px;
`;

export const Description = styled.div`
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
`;
